export class Modulo {
  id_area: number;
  id_bloque: number;
  id_modulo: number;
  abr: string;
  descripcion: string;

  constructor(){
    this.id_bloque = 0;
    this.id_area = 0;
    this.id_modulo = 0;
    this.abr = "";
    this.descripcion = "";
  }

}



// WEBPACK FOOTER //
// ./src/app/_models/modulo.model.ts